import { style } from "@vanilla-extract/css";
import { vars } from "plos/src/styles";

export const playerNotesContainer = style({
  borderRadius: vars.radii.m,
  backgroundColor: vars.colors.surface,
  padding: vars.space.m,
});

// TODO: fix this
export const playerNotesHeading = style({
  display: "flex",
  justifyContent: "space-between",
  gap: vars.space.s,
  width: "100%",
  fontSize: vars.fontSizes.body.m,
  WebkitTapHighlightColor: "transparent",
  selectors: {
    '[data-expanded="true"] &': {
      marginBottom: vars.space.s,
    },
  },
});

export const playerNotesContent = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.s,
  selectors: {
    "&[hidden]": {
      display: "none !important", // Force Safari to hide closed panels
    },
  },
});

export const chevronDown = style({
  display: "block",
  transformOrigin: "center",
  transition: "transform 0.2s",
  width: 20,
  height: 20,
  fill: vars.colors.onSurface,
  selectors: {
    '[data-expanded="true"] &': {
      transform: "rotate(-180deg)",
    },
  },
});

export const playerNotesItem = style({
  display: "flex",
  alignItems: "center",
  gap: vars.space.s,
});

export const playerNotesItemContent = style({
  display: "flex",
  flexDirection: "column",
});

export const playerNotesDropdownIconContainer = style({
  display: "inline-block",
  minWidth: 16,
  minHeight: 16,
});
